import { NextSeo } from "next-seo";
import Navbar from "../components/navbar";
import Image from "next/image";

export default function CarolsStory() {
  return (
    <div>
      <NextSeo title="Carol's Story" />
      <Navbar />
      <div className="bg-gradient-to-r from-violet-50 to-fuchsia-50 py-20">
        <div className="relative w-full px-6 py-12 bg-white shadow-xl shadow-slate-700/10 ring-1 ring-gray-900/5 md:max-w-3xl md:mx-auto lg:max-w-4xl lg:pt-16 lg:pb-28">
          <div className="prose  mx-auto container">
            <h1>Carol&apos;s Story</h1>
            {/* <img src="/familyphoto2020.jpg" alt="Family2020" /> */}
            <div className="relative aspect-video">
              <Image
                src="/familyphoto2024-2.jpg"
                quality={100}
                alt="Family2020"
                layout="fill"
                objectFit="contain"
                style={{ filter: "brightness(1.1)" }}
              />
            </div>
            <p>
              One evening I leaned over to look at something my husband was
              reading on his computer. As I touched his back, my left breast
              felt extremely sore. After doing a self-exam of my breast it
              appeared red and swollen. The next day I visited my gynecologist
              who immediately recommended me to a local imaging center for a
              mammogram. On June 6, 2013 I was diagnosed with Inflammatory
              Breast Cancer. The imaging center said I had little to no chance
              of survival. Inflammatory breast cancer is a rare and very
              aggressive disease with symptoms that include redness, swelling,
              tenderness and warmth in the breast. Inflammatory breast cancer
              accounts for 1 to 5 percent of all breast cancers diagnosed in the
              United States.
            </p>
            <blockquote>
              My husband sat in the waiting room numb and in disbelief with my
              diagnosis
            </blockquote>
            <p>
              My husband sat in the waiting room numb and in disbelief with my
              diagnosis. I received annual mammograms, exercised, ate healthy
              and always had a positive attitude about life. I taught nutrition
              for several years and presently teach courses on Attaining the
              Mental Edge at a local Pittsburgh college. How could someone who
              tried to do everything right to prevent breast cancer be diagnosed
              with this devastating disease?
            </p>
            <p>
              My tumor started as an eight-by-seven centimeter mass in my left
              breast. I was shocked. There is no breast cancer in my family
              history and I was receiving periodic mammograms. However,
              inflammatory breast cancer progresses rapidly, often in a matter
              of weeks or months. When you are diagnosed with inflammatory
              breast cancer it’s typically at stage 3 or 4.
            </p>
            <p>
              Dr. Thomas Julian, a surgical oncologist and breast cancer
              specialist at Allegheny General Hospital (AGH), part of the
              Pittsburgh-based Allegheny Health Network, informed me about a
              clinical trial underway at the hospital of an investigational drug
              for inflammatory breast cancer, called Neratinib, that targets and
              blocks proteins that help cancer cells to grow.
            </p>
            <blockquote>
              Once accepted and enrolled in the clinical trial, the results of
              the treatment were almost immediate for me
            </blockquote>
            <p>
              Once accepted and enrolled in the clinical trial, the results of
              the treatment were almost immediate for me. On July 17, 2013, I
              was informed the tumor in my breast was nearly gone. After
              weeks/months of receiving chemotherapy, radiation and having a
              mastectomy, I was declared cancer free.
            </p>
            <p>
              I founded the Glock Foundation to raise funds and inform breast
              cancer patients how significant and possibly lifesaving
              participating in a clinical trial can be upon their diagnosis.
              There is more oversight in a clinical trial than the standard care
              protocol. This process not only saved my life but could save the
              lives of so many other breast cancer patients.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
